import dayjs from "dayjs";

export const getRelativeTime = (date: Date) => {
    const now = dayjs();
    const postDate = dayjs(date);
    const diffInSeconds = now.diff(postDate, 'second');
    const diffInMinutes = now.diff(postDate, 'minute');
    const diffInHours = now.diff(postDate, 'hour');
    const diffInDays = now.diff(postDate, 'day');
  
    if (diffInSeconds < 60) {
      return `${diffInSeconds} seconds ago`;
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes} minutes ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hours ago`;
    } else {
      return `${diffInDays} days ago`;
    }
};